export default __webpack_public_path__ + "static/media/private.efadd774.svg";